import { combineReducers } from '@reduxjs/toolkit';
import lock from './lockSlice';

const reducer = combineReducers({
  lock,
});

export default reducer;
